import { Address, VehicleProperties } from './vehicle';

export interface OfferQuery {
  id?: number;
  tenant_id: number;
  strategy: OfferQueryStrategy;
  emailTo: string[];
  firstSentNotBefore: string;
  lastSentNotAfter: string;
  lastSentAt: string;
  active: boolean;
  nextSendNotBefore: string;
  emailReplyTo: string;
  emailBodyGenerationPrompt: string;
  startArea: Address;
  endArea: Address;
  vehicleProperties: VehicleProperties;
  emailIds: string[];
}

export enum OfferQueryActive {
    INACTIVE = 0,
    ACTIVE = 1
}

export enum OfferQueryStrategy {
    DAILY = 0,
    WEEKLY = 1
}
